function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React from 'react';
import { Text, Flex, Box, Stack, Circle } from '@tapresearch/ui/components';
import { useColorScheme } from '../../../project/longitudinal-results';
export function CustomCrossTabTooltip(param) {
    var barData = param.barData, answersById = param.answersById;
    var colors = useColorScheme();
    var hoveredAnswerId = barData.id, answerValues = barData.data;
    return /*#__PURE__*/ React.createElement(Box, {
        rounded: "md",
        boxShadow: "2xl",
        bg: "white",
        overflow: "hidden",
        py: 4,
        px: 2
    }, /*#__PURE__*/ React.createElement(Box, {
        pb: 2,
        px: 2,
        mb: 2,
        color: "gray.700",
        fontSize: "md",
        fontWeight: "medium"
    }, barData.indexValue), /*#__PURE__*/ React.createElement(Stack, {
        spacing: 2
    }, Object.entries(answersById).map(function(param, i) {
        var _param = _sliced_to_array(param, 2), answerId = _param[0], answerAttributes = _param[1];
        var isHoveredOption = hoveredAnswerId === answerId.toString();
        if (!answerValues[answerId]) {
            return null;
        }
        return /*#__PURE__*/ React.createElement(Flex, _object_spread({
            key: i,
            justify: "space-between",
            align: "center",
            color: "gray.600",
            py: 2,
            px: 3,
            rounded: "md",
            fontSize: "sm",
            fontWeight: "normal"
        }, isHoveredOption && {
            fontWeight: 'semibold',
            color: 'gray.800',
            border: '1px solid',
            borderColor: colors[i]
        }), /*#__PURE__*/ React.createElement(Flex, {
            align: "center"
        }, /*#__PURE__*/ React.createElement(Circle, {
            as: Flex,
            alignItems: "center",
            bgColor: colors[i],
            h: 3,
            w: 3,
            mr: 2
        }), answerAttributes.option_text), /*#__PURE__*/ React.createElement(Flex, {
            fontWeight: "bold",
            color: "gray.800",
            ml: 4
        }, /*#__PURE__*/ React.createElement(Text, null, answerValues[answerId].toString() + '%'), /*#__PURE__*/ React.createElement(Text, {
            ml: 1
        }, "(", answerValues[answerId.toString() + '_total'], ")")));
    })));
}
